<template>
  <div class="d-flex flex-column">
    <small v-if="error" class="text-danger mb-3">{{ error }}</small>
    <small v-if="success" class="text-success mb-3">{{ success }}</small>
    <span v-if="loading" class="spinner-border spinner-border-sm"/>
    <div >
      <slot/>
    </div>
  </div>
</template>

<script>
export default {
  name: "FLoader",
  data() {
    return {
      loading: false,
      error: null,
      success: null,
    }
  },
  methods: {
    async wrap(callback, noSpinner) {
      this.clear();
      this.loading=!noSpinner;
      try {
        this.success = await callback();
      } catch (e) {
        this.error = e.message;
      }
      this.loading = false;
      return !this.error;
    },
    clear() {
      this.loading = false;
      this.error = null;
      this.success = null;
    },
  },
}
</script>